var map = {
	"./karamoja1.jpg": "98bb",
	"./karamoja2.jpg": "225e",
	"./karamoja3.jpg": "567c",
	"./karamoja4.jpg": "4982",
	"./manafwa1.jpg": "4f5b",
	"./manafwa9.jpg": "14c2",
	"./mombasa1.jpg": "2549",
	"./mombasa2.jpg": "5918",
	"./nairobi1.jpg": "a6e6",
	"./nairobi2.jpg": "4c37",
	"./nairobi3.jpg": "1d1a",
	"./nairobi4.jpg": "037c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "92e8";